<template>
    <div class="relative z-10 bg-inherit gap-4 gap-y-4 tiptap ProseMirror container flex flex-col">
        <div class="col-span-full md:!col-start-3 md:col-span-4 lg:!col-start-4 lg:col-span-3 flex flex-col gap-4">
            <div class="view-h3 col-span-2">{{ getLocalizedValue(content?.['left-title']) }}</div>
            <RenderedHTML :value="leftColumn"></RenderedHTML>
        </div>
        <div class="col-span-full md:col-span-4 lg:col-start-7 lg:col-span-3 flex flex-col gap-4">
            <div class="view-h3 col-span-2">{{ getLocalizedValue(content?.['right-title']) }}</div>
            <RenderedHTML :value="rightColumn"></RenderedHTML>
        </div>
    </div>
</template>

<script lang="ts" setup>
import RenderedHTML from "~/components/view/RenderedHTML.vue"

const {get_value: getLocalizedValue} = useLocalizedValue()

const { content } = defineProps({
    content: {
        type: Object
    },
    image: {
        required: false,
        type: String
    },
    properties: {
        type: Array as PropType<{translate: boolean, label: string}[]>
    }
})

const normalizeColumnDocument = (value: any): any => {
    if (!value || typeof value !== 'object') return value

    if (value.type === 'column') {
        return {
            ...value,
            type: 'doc'
        }
    }

    if (!value.type && !Array.isArray(value)) {
        return Object.fromEntries(
            Object.entries(value).map(([locale, localeValue]) => [
                locale,
                normalizeColumnDocument(localeValue)
            ])
        )
    }

    return value
}

const leftColumn = computed(() => normalizeColumnDocument(content?.['left-column']))
const rightColumn = computed(() => normalizeColumnDocument(content?.['right-column']))

</script>
